import { IGetGamesFeedResponse } from 'libs/games/src/hooks/api/getGamesFeed';
import { PlatformType } from '../../../types';
import {
  mapServiceIdsToProviderIds,
  parseGamesListFromCms
} from '../../normalize';
import { GamesStorageType } from '../../types';

type GetGamesStatePreparator = (args: {
  disabledProviders: string[];
  feedNames: string;
  platform: PlatformType;
  state: GamesStorageType;
  data: IGetGamesFeedResponse;
}) => GamesStorageType;

export const getGamesStatePreparator: GetGamesStatePreparator = ({
  disabledProviders,
  feedNames,
  platform,
  state,
  data
}) => {
  const parsedFeed = parseGamesListFromCms(
    data,
    disabledProviders,
    feedNames,
    platform
  );
  const serviceIdToProviderId = mapServiceIdsToProviderIds(
    parsedFeed.providers?.data
  );
  return {
    ...state,
    feeds: {
      ...state.feeds,
      [feedNames]: {
        categories: parsedFeed.categories,
        platform,
        providersGames: parsedFeed.providers.feedProvidersGames,
        providersIds: parsedFeed.providers.feedProvidersIds,
        gamesIds: parsedFeed.games.ids,
        isLoading: false,
        isLoaded: true
      }
    },
    games: {
      ...state.games,
      data: {
        ...state.games.data,
        ...parsedFeed.games.data
      },
      launchIdToGameId: {
        ...state.games.launchIdToGameId,
        ...parsedFeed.games.launchIdToGameId
      },
      ids: [
        ...new Set([
          ...(state.games.ids || []),
          ...(parsedFeed.games.ids || [])
        ])
      ]
    },
    providers: {
      ...state.providers,
      data: {
        ...state.providers.data,
        ...parsedFeed.providers.data
      },
      serviceIdToProviderId: {
        ...state.providers.serviceIdToProviderId,
        ...serviceIdToProviderId
      }
    }
  };
};
